<template>
  <div
    class="TNovoProfissional"
    data-testid="TNovoProfissional"
  >
    <div class="TNovoProfissional__Header">
      <slot name="navegacao" />
    </div>
    <form autocomplete="off">
      <slot name="perfil" />
      <slot name="menuaba" />
      <div class="TNovoProfissional__BodyTab">
        <slot name="centro" />
      </div>
      <slot name="rodape" />
    </form>
    <slot name="modais" />
  </div>
</template>
<style lang="scss" scoped>
  .TNovoProfissional {
    margin-top: 1.4rem;
  }
  .TNovoProfissional__Header {
    display: flex;
    align-items: flex-end;
    margin-bottom: 2rem;
    width: 100%;
    min-height: 42px;
  }
  :deep(.p-tabmenu .p-tabmenu-nav) {
    z-index: 0;
    position: relative;
    width: 100%;
  }
  :deep(.p-tabmenuitem) {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  :deep(.p-tabmenuitem a) {
    width: 100%;
    justify-content: center;
    text-align: end;
  }
</style>
